import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import background from "../assets/background.png";
import videoSrc from "../assets/video.mp4";

export default function Landing() {
  const [playing, setPlaying] = useState(false);
  const [zoomVideo, setZoomVideo] = useState(false);

  const videoRef = useRef(null);
  const navigate = useNavigate();

  const handleClick = async () => {
    if (playing) return;

    setPlaying(true);

    const v = videoRef.current;
    if (!v) return;

    try {
      v.currentTime = 0;
      v.muted = true;
      v.playsInline = true;
      await v.play();
    } catch (e) {
      console.error("Video play failed:", e);
    }
  };

  const handleTimeUpdate = () => {
    const v = videoRef.current;
    if (!v) return;

    // Start zoom + fade in last 0.4s
    const remaining = v.duration - v.currentTime;
    if (!zoomVideo && remaining <= 1) {
      setZoomVideo(true);
    }
  };

  const handleEnded = () => {
    navigate("/second");
  };

  return (
    <div className="landing" onClick={handleClick}>
      <img className="bg" src={background} alt="" />

      {/* VIDEO */}
      <motion.video
        ref={videoRef}
        className={`bgVideo ${playing ? "show" : ""}`}
        src={videoSrc}
        muted
        playsInline
        preload="auto"
        onTimeUpdate={handleTimeUpdate}
        onEnded={handleEnded}
        animate={zoomVideo ? { scale: 2.3 } : { scale: 1 }}
        transition={{ duration: 6, ease: [0.2, 5, 0.2, 1] }}
      />

      {/* FADE TO WHITE OVERLAY */}
      <motion.div
        className="whiteFade"
        initial={{ opacity: 0 }}
        animate={zoomVideo ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 3, ease: "easeOut" }}
      />

      {/* UI on top */}
      <div className="stage">
        <div className="envelope">
          <div className="flap" />
          <div className="env-body" />
        </div>
      </div>
    </div>
  );
}
